import { registerBlockType } from "@wordpress/blocks";
import config from "./block.json";
import DefaultEditor from "../../../source/components/DefaultEditor";

registerBlockType(config.name, {
  ...config,
  edit: DefaultEditor,
  save() {
    return null;
  },
});
